export const apiPath = '/v2/risk_profiles';
const actionType = 'RISK_PROFILE';

export default actionType;
